import React from 'react'
import './Getstarted.css'
import {Link} from 'react-router-dom'

const Business = () => {
  return (




    <div>


      <div className='getstarted'>
        
        <h3>Welcome</h3>


        <div className='getlinks'>
        <Link to='./Individual' className='but'>Individual</Link>
        <Link to='./Business' className='but butactive'>Business</Link>
        </div>
       



      <div className='inputs'>

       <input className='datas' type="text" name="username" id="" placeholder='Username' required />
       
       <input className='datas' type="text" name="businessName" id="" placeholder='Business Name' required />

       <input className='datas' type="email" name="Email" id="" placeholder='E-mail' required />

       <input className='datas' type="tel" name="telephone" id="" placeholder='Phone Number' required />

       <input className='datas' type="text" name="Referal" id="" placeholder='Referal Code (Optional)' required />

       <p>By clicking the Sign Up button below, you agree to TradExpress <a className='getanchor' href=""> terms and service </a></p>

       {/* <button className='sign'>Sign Up</button> */}
       <Link to='./Verify' className='sign'>Sign Up</Link>

       <p>Already have an account? <Link  to='./Login' className='getanchor'>Click here</Link></p>

      </div>
      </div>



    </div>
  )
}

export default Business